import { render, staticRenderFns } from "./TitleCreditName.vue?vue&type=template&id=281d7a46&scoped=true"
import script from "./TitleCreditName.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleCreditName.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleCreditName.vue?vue&type=style&index=0&id=281d7a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281d7a46",
  null
  
)

export default component.exports